/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionInviteOnlineVideosession} from '../../../store/actions/actions-videosession';
import {
  ActionGetUsersPublicList,
  ActionAddUserToContacts,
  ActionStoreServerData,
  ActionGetContacts,
} from '../../../store/actions/actions-request';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import defaultUser from '../../../assets/images/required/user.png';
import {getUserNameFromString} from '../../../services/common';
import NoResult from '../../NoResult/NoResult';

class ModalAddContacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
    };
    this.searchContacts = _.debounce(this.searchContactsData, 500);
    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-top find-contact',
      closeButton: true,
      keyboard: true,
    });
  }

  componentDidMount() {
    this.props.ActionStoreServerData('usersList', []);
  }

  componentWillUnmount() {
    this.props.ActionStoreServerData('usersList', []);
  }

  getDefaultContacts = (data = {}) => {
    const reqData = {
      perPage: 4,
      ...data,
    };

    this.props.ActionGetUsersPublicList(reqData);
  };

  getContacts = () => {
    this.props.ActionGetContacts();
  };

  onCloseClick = () => {
    this.props.ActionModalHide();
  };

  afterAddToContactList = () => {
    this.searchContacts();
    this.getContacts();
    if (this.props.callback) {
      this.props.callback();
    }
  };

  onAddToContactList = (userId) => {
    this.props.ActionAddUserToContacts(userId, this.afterAddToContactList);
  };

  renderContactList = () => {
    const {usersList = [], usersListLoading} = this.props;
    const {searchInput} = this.state;

    if (searchInput.length >= 3 && !usersListLoading && !usersList.length) {
      return (<NoResult />);
    }

    if (!usersList.length || searchInput.length < 3) return null;

    return (
      <ul className="contact-result_list custom-scroll-small">
        {usersList.map((contact, index) => (
          <li className="contact-result_item" key={index}>
            <div className="contact-result_item_user">
              <div className="user-image">
                <img src={contact.photoUrl || defaultUser} alt="" />
              </div>
              <div className="contact-info" style={!contact.companyName ? {alignSelf: 'center'} : null}>
                <div className="contact-name" style={null}>{getUserNameFromString(contact.name, true)}</div>
                {contact.companyName && <div className="contact-work">{contact.companyName}</div>}
              </div>
            </div>
            {!contact.isContact
              && (
                <button
                  type="button"
                  className="button_add-contact btn btn-base btn-icon-left"
                  title="Добавить в контакты"
                  onClick={() => this.onAddToContactList(contact._id)}
                >
                  <span className="button_add-contact_text">
                    Добавить в контакты
                  </span>
                </button>
              )}
          </li>
        ))}
      </ul>
    );
  };

  onChangeSearchInput = (e) => {
    const {value} = e.target;

    this.setState({
      searchInput: value,
    }, () => {
      if (value.length >= 3) {
        this.searchContacts();
      }

      if (value.length <= 2) {
        this.props.ActionStoreServerData('usersList', []);
      }
    });
  };

  searchContactsData = () => {
    const {searchInput} = this.state;
    const searchData = {
      perPage: 10,
      filter: {
        name: searchInput,
      },
    };

    this.getDefaultContacts(searchInput ? searchData : {});
  };

  render() {
    const {searchInput} = this.state;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-header">
            <h3 className="modal-header_title">Найти и добавить контакт</h3>
            <button type="button" className="modal-close-btn" onClick={this.onCloseClick}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal-content">
            <input
              type="search"
              placeholder="Введите имя, фамилию или номер телефона"
              onChange={this.onChangeSearchInput}
              value={searchInput}
            />
            {this.renderContactList()}
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalAddContacts.defaultProps = {
  usersList: [],
};

ModalAddContacts.propTypes = {};

function mapStateToProps({
  rServerData, rUser, rSession, rLoading,
}) {
  return {
    usersList: rServerData.usersList,
    user: rUser,
    isLoggedIn: rSession.LOGGED_IN,
    usersListLoading: rLoading.usersListLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionInviteOnlineVideosession,
    ActionGetUsersPublicList,
    ActionAddUserToContacts,
    ActionStoreServerData,
    ActionGetContacts,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddContacts);
